import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { ref, Ref, watchEffect } from 'vue';
import ParamSelector from '@/components/task/ParamSelector.vue';
import { TaskTypeEnum } from "@/store/modules/task/types";
import type { FormInstance } from 'element-plus'
import { fileUploadLabel, newTaskLabelMap, CreateTaskOption } from '@/store/modules/task/types';

import { defineComponent, reactive } from 'vue';

const __default__ = defineComponent({
  name: "GenTask",
});

interface Task {
  taskType: number,
  options: CreateTaskOption[]
}

interface CreateTaskForm {
  projId: string,
  task: Task[],
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  projId: {
    type: String,
    required: true,
  },
  uid: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const getContentParamByType = (taskType: number): CreateTaskOption[] => {
  let paramList = newTaskLabelMap.get(taskType);
  if (typeof (paramList) !== "undefined") {
    return paramList[1];
  }
  return [];
};

const getDefaultContentParamByType = (taskType: number): any => {
  let paramList = newTaskLabelMap.get(taskType);
  let form: { [key: string]: string | { [key: string]: string } } = {}
  if (typeof (paramList) !== "undefined") {
    paramList[1].forEach((param) => {
      if (param.children) {
        form[param.name] = 'false'
      } else {
        form[param.name] = ""
      }
    })
    return form
  }
  return {};
};

const formRef = ref<FormInstance>()
const childRefs: Ref<(typeof ParamSelector)[]> = ref<[]>([])


const createTaskForm: any = reactive({
  projId: props.projId,
  task: [{
    ...{
      taskType: TaskTypeEnum.TgMsgCode,
      options: getDefaultContentParamByType(TaskTypeEnum.TgMsgCode)
    }
  }]
})

const taskTypeList = [
  {
    value: TaskTypeEnum.FileConstructionCode,
    label: '文件结构',
  },
  {
    value: TaskTypeEnum.TgMsgCode,
    label: 'Telegram',
  },
  {
    value: TaskTypeEnum.WeChatMsgCode,
    label: '微信',
  },
  {
    value: TaskTypeEnum.BrowserCode,
    label: '浏览器信息',
  },
  {
    value: TaskTypeEnum.SkypeMsgCode,
    label: 'skype',
  },
];
const getFileParamByType = (taskType: number): fileUploadLabel[] => {
  let paramList = newTaskLabelMap.get(taskType);
  if (typeof (paramList) !== "undefined") {
    return paramList[0];
  }
  return [];
};

const createOnSubmit = async (formEl: FormInstance | undefined) => {
  try {
    if (!formEl) return
    formEl.validate((valid) => {
      if (valid) {
        createTaskForm.task.forEach((t, index) => {
          if (childRefs.value[index]) {
            childRefs.value[index].submitCreateTask()
          }
        })
      } else {
        console.log("failed")
      }
    })
  } catch (err) {
    console.log(err)
  }
}

const deleteMessage = (index: number) => {
  createTaskForm.task.splice(index, 1)
}

const addUpload = () => {
  createTaskForm.task.push({
    ...{
      taskType: TaskTypeEnum.TgMsgCode,
      options: getDefaultContentParamByType(TaskTypeEnum.TgMsgCode)
    }
  })
}

const handleTypeChange = (index: number, type: number) => {
  createTaskForm.task[index].options = getDefaultContentParamByType(type)
}



return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    model: createTaskForm,
    "label-width": "150px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "项目ID",
        prop: "projId"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.projId), 1)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(createTaskForm.task, (task, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_el_divider, { "content-position": "left" }, {
            default: _withCtx(() => [
              _createTextVNode(" task " + _toDisplayString(index + 1) + " ", 1),
              _createVNode(_component_el_divider, { direction: "vertical" }),
              _createVNode(_component_el_link, {
                type: "primary",
                style: {"float":"right"},
                onClick: ($event: any) => (deleteMessage(index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_form_item, {
            label: "任务类型",
            prop: 'createTaskForm.task.' + index + '.taskType'
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: createTaskForm.task[index].taskType,
                "onUpdate:modelValue": ($event: any) => ((createTaskForm.task[index].taskType) = $event),
                placeholder: "Select",
                size: "large",
                style: {"width":"240px"},
                onChange: ($event: any) => (handleTypeChange(index, createTaskForm.task[index].taskType))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(taskTypeList, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 2
          }, 1032, ["prop"]),
          _createVNode(ParamSelector, {
            ref_for: true,
            ref_key: "childRefs",
            ref: childRefs,
            projId: props.projId,
            uid: props.uid,
            taskType: createTaskForm.task[index].taskType,
            createTaskForm: createTaskForm.task[index].options,
            fileList: getFileParamByType(createTaskForm.task[index].taskType),
            contentList: getContentParamByType(createTaskForm.task[index].taskType),
            itemProp: 'task.' + index + '.options'
          }, null, 8, ["projId", "uid", "taskType", "createTaskForm", "fileList", "contentList", "itemProp"])
        ]))
      }), 128)),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (createOnSubmit(formRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("创建任务")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addUpload()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("新增任务")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})